import React, { useEffect } from "react";
import "./App.css";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import banner from "./src/img/app-banner.jpg";
import metafin from "./src/img/metafinlogo.png";
import step1 from "./src/img/step-01.png";
import step2 from "./src/img/step-02.png";
import step3 from "./src/img/step-03.png";
import check from "./src/img/check.png";

function Location() {
  const location = useLocation();
  useEffect(() => {
    downloadPage(false);
    // eslint-disable-next-line
  }, []);

  function downloadPage(redirect) {
    getReferral();
    var ua = navigator.userAgent.toLowerCase();
    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if (isAndroid) {
      window.location = `https://play.google.com/store/apps/details?id=my.com.mxm.medisaversapp1&pcampaignid=web_share&referrer=${getReferral()}`;
    } else {
      if (redirect)
        window.location = `https://apps.apple.com/my/app/metafin-digital/id1198893279`;
    }
  }

  const getReferral = () => {
    if (!document.hasFocus()) return;
    const queryString = location.search;
    const urlParams = new URLSearchParams(queryString);

    const referral = urlParams.get("referrer");

    console.log("referral is " + referral);
    localStorage.setItem("refer", referral);
    if (!!referral) {
      navigator.clipboard.writeText(`refer=${referral}`);
      return referral;
    }
  };

  return (
    <div onClick={getReferral} className="refer-cont">
      <img className="logo" src={metafin} alt="" />{" "}
      {/* <div className="refer-desc">
        <h4> 🎉Claim Your FREE Vouchers Worth Up to RM200!🎉 </h4>{" "}
      </div> */}
      <img className="banner" src={banner} alt="" />{" "}
      {/* <div className="mybutton" onClick={() => downloadPage(true)}>
        Download Now!
      </div> */}
      {/* <div className="refer-desc-text">
        <p>
          Download the MetaFin Digital App and register to instantly unlock your
          rewards. Plus, refer the app to your friends and earn even more
          rewards while they enjoy fantastic savings!
        </p>
        <p>
          Discover MetaFin DIY Digital Platform, the ultimate place for managing
          over 20 insurance and lifestyle products effortlessly.
          🚗🛵✈️🏠👔🦷🩺🧑🏻‍🦽🫀📝
        </p>
        <p>
          Don’t miss out—start earning and save for your next purchases with the
          MetaFin DIY Digital Platform today. How sweet is that? 🌟📲
        </p>
      </div> */}
      <div className="refer-desc">
        <div className="refer-desc-item pink">
          <div className="circle check">
            <img src={check} alt="" />
          </div>
          <div className="line check" />
          <span>
            <img src={step1} alt="" />
          </span>
          <div className="refer-item-desc">
            <h4>You’re here</h4>
            <p>Download the MetaFin DIY Digital app now to kick things off.</p>
            <div className="mybutton" onClick={() => downloadPage(true)}>
              Download Now!
            </div>
          </div>
        </div>
        <div className="refer-desc-item">
          <div className="circle" />

          <span>
            <img src={step2} alt="" />
          </span>
          <div className="refer-item-desc">
            <h4>Register Your Account</h4>
            <p>
              Register Your Account Register to unlock all the rewarding
              features.
            </p>
          </div>
        </div>
        <div className="refer-desc-item">
          <div className="line" />
          <div className="circle grey" />
          <div className="line grey" />
          <span className="scaler">
            <img className="treasure" src={step3} alt="" />
          </span>

          <div className="refer-item-desc">
            <h4>
              Claim Your <b>RM200</b> Vouchers!
            </h4>
            <p>Almost there! Get your vouchers and start exploring</p>
          </div>
        </div>
      </div>
    </div>
  );
}
function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index element={<Location />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
